import { dynamicLoader } from '~/utils';

export const EstimatesPage = dynamicLoader({
  name: 'EstimatesPage',
  importFunc: () => import('./estimates'),
});